import { Box, Button, Paper, Typography } from "@mui/material";
import { ViewContainer } from "../../components/view-container";
import { useState } from "react";
import { RequestPasswordReset } from "./request-password-reset";
import { ResetPasswordForm } from "./reset-password-form";
import WestIcon from "@mui/icons-material/West";
import { Views } from "../../utils/types";
import { useNavigate } from "react-router";
import { fullBleedViewSx } from "../../utils/colors";

type Step = "request" | "sent" | "reset";

export const ResetPasswordView = () => {
  const navigate = useNavigate();

  // If WordPress sent the user here via an email link, key and login
  // (user_login) will be in the URL — go straight to the reset form.
  const params = new URLSearchParams(window.location.search);
  const urlKey = params.get("key") ?? "";
  const urlLogin = params.get("login") ?? "";
  const hasUrlToken = Boolean(urlKey && urlLogin);

  const [step, setStep] = useState<Step>(hasUrlToken ? "reset" : "request");

  return (
    <ViewContainer
      className="asset-table-view"
      sx={{
        ...fullBleedViewSx,
        p: 2,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <Box sx={{ mt: "20vh", mx: "auto", maxWidth: 600 }}>
        <Button
          variant="text"
          color="secondary"
          startIcon={<WestIcon />}
          onClick={() => navigate(Views.SIGN_IN)}
        >
          Back
        </Button>
        <Paper sx={{ p: 2, mt: 1 }}>
          <Typography variant="h4" mb={2}>
            Reset Password
          </Typography>

          {step === "request" && (
            <RequestPasswordReset onRequestSuccess={() => setStep("sent")} />
          )}

          {step === "sent" && (
            <Typography variant="body1">
              A password reset link has been sent to your email address. Click
              the link in the email to set a new password.
            </Typography>
          )}

          {step === "reset" && (
            <ResetPasswordForm resetKey={urlKey} login={urlLogin} />
          )}
        </Paper>
      </Box>
    </ViewContainer>
  );
};
